import {
  validateModules,
  type ModuleConfig,
  type ModuleSource,
} from '@berky/module-contract'

/**
 * Modul-Discovery.
 *
 * Die Shell sucht zur Buildzeit alle `module.config.ts` unterhalb von
 * `modules/`. Ein neues Modul erscheint dadurch automatisch — es muss keine
 * einzige bestehende Datei geändert werden. Genau das ist der Kern des
 * gesamten Aufbaus; bitte nicht durch eine Registrierungsliste ersetzen.
 */
const found = import.meta.glob<{ default: ModuleConfig }>(
  '../../../../modules/*/frontend/module.config.ts',
  { eager: true },
)

const sources: ModuleSource[] = Object.entries(found).map(([path, loaded]) => ({
  path,
  config: loaded.default,
}))

let discovered: ModuleConfig[] = []
let discoveryError: Error | null = null

try {
  discovered = validateModules(sources)
    .filter((module) => module.enabled !== false)
    .sort((a, b) => a.order - b.order)
} catch (error) {
  // Nicht werfen: main.tsx zeigt daraus eine lesbare Seite statt eines weißen
  // Bildschirms mit Konsolenfehler.
  discoveryError = error instanceof Error ? error : new Error(String(error))
}

/** Alle aktiven Module, nach `order` sortiert. */
export const modules = discovered

/** Die kleine, für Fachmodule freigegebene Sicht auf den Modulkatalog. */
export const moduleReferences = modules.map(({ id, title }) => ({ id, title }))

/** Gesetzt, wenn mindestens ein Manifest fehlerhaft ist. */
export const moduleError = discoveryError

/** Findet ein Modul anhand seiner id. */
export function findModule(id: string): ModuleConfig | undefined {
  return modules.find((module) => module.id === id)
}
